document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".filters-toggle");
  const panel = document.getElementById("filters-panel");
  const overlay = document.getElementById("filters-overlay");
  const closeBtn = document.querySelector(".filters-close");

  function openFilters() {
    panel.classList.add("open");
    panel.classList.remove("hidden");
    overlay.classList.remove("hidden");
    overlay.classList.add("open");
    //document.body.classList.add("no-scroll");
  }

  function closeFilters() {
    panel.classList.remove("open");
    setTimeout(() => panel.classList.add("hidden"), 300);
    overlay.classList.add("hidden");
    overlay.classList.remove("open");
    document.body.classList.remove("no-scroll");
  }

  toggleBtn.addEventListener("click", openFilters);
  closeBtn.addEventListener("click", closeFilters);
  overlay.addEventListener("click", closeFilters);
  document.body.classList.remove("no-scroll");
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    const toggle = e.target.closest(".sort-popup__toggle");
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      const popup = toggle.closest(".sort-popup");
      if (!popup) return;
      const menu = popup.querySelector(".sort-popup__menu");
      const plus = popup.querySelector(".sort-popup__toggle_plus");
      const minus = popup.querySelector(".sort-popup__toggle_minus");
      if (!menu) return;
      const willOpen = menu.style.display !== "block";
      menu.style.display = willOpen ? "block" : "none";
      if (plus) plus.style.display = willOpen ? "none" : "inline";
      if (minus) minus.style.display = willOpen ? "inline" : "none";
      return;
    }
    if (e.target.closest(".sort-popup")) return;
    document.querySelectorAll(".sort-popup__menu").forEach(function (m) {
      m.style.display = "none";
    });
    document.querySelectorAll(".sort-popup .sort-popup__toggle_plus").forEach(function (p) {
      p.style.display = "inline";
    });
    document.querySelectorAll(".sort-popup .sort-popup__toggle_minus").forEach(function (m) {
      m.style.display = "none";
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const clearBtn = document.getElementById("ClearAllFilters");
  if (clearBtn) {
    clearBtn.addEventListener("click", clearAllFilters);
  }
});

function updateActiveFiltersCount() {
  const checkedCheckboxes = document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]:checked');
  const selectedSelects = Array.from(document.querySelectorAll('#FacetFiltersForm select')).filter(sel => sel.value && sel.value !== '');
  const count = checkedCheckboxes.length + selectedSelects.length;
  const counterEl = document.querySelector('.filters-count');
  const buttons = document.querySelector(".filters-buttons");
  if (counterEl) {
    if (count > 0) {
      buttons.style.display = 'block';
      counterEl.textContent = "(" + count + ")";
      counterEl.style.display = 'inline-block';
    } else {
      counterEl.style.display = 'none';
      buttons.style.display = 'none';
    }
  }
}

function clearAllFilters() {
  document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach((checkbox) => {
    checkbox.checked = false;
  });

  const minPrice = document.querySelector('input[name="filter.v.price.gte"]');
  const maxPrice = document.querySelector('input[name="filter.v.price.lte"]');
  if (minPrice) minPrice.value = '';
  if (maxPrice) maxPrice.value = '';

  document.querySelectorAll('#FacetFiltersForm select').forEach((select) => {
    select.value = '';
  });

  const form = document.querySelector('#FacetFiltersForm');
  if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
}


!(function () {
    "use strict";
    var e,
        t = {
            5170: function (e, t, r) {
                var n = r(4559),
                    o = r(1028),
                    c = r(9402),
                    i = r.n(c);
                document.addEventListener("DOMContentLoaded", function () {
                    window.matchMedia("screen and (min-width: 1024px)").matches &&
                        document.getElementById("main-collection-filters") &&
                        document.getElementById("main-collection-filters-container") &&
                        new (i())("#main-collection-filters", { stickTo: "#main-collection-filters-container", top: 120 }),
                        window.matchMedia("screen and (min-width: 1024px)").matches &&
                            document.getElementById("shopify-section-menu-collection") &&
                            document.querySelector(".facets") &&
                            new (i())(".facets", { stickTo: "#shopify-section-menu-collection", top: 120 });
                    const e = [].slice.call(document.querySelectorAll(".sticky"));
                    if ("IntersectionObserver" in window) {
                        const t = new IntersectionObserver(
                            (e) => {
                                let [t] = e;
                                return t.target.classList.toggle("is-sticky", t.intersectionRatio < 1);
                            },
                            { rootMargin: "-1px 0px 0px 0px", threshold: [1] }
                        );
                        e.forEach(function (e) {
                            t.observe(e);
                        });
                    }
                });
                class a extends HTMLElement {
                    constructor() {
                        super(),
                            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
                            (this.debouncedOnSubmit = (0, n.sg)((e) => {
                                this.onSubmitHandler(e);
                            }, 500)),
                            this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
                        const e = this.querySelector("#FacetsWrapper");
                        e && e.addEventListener("keyup", onKeyUpEscape);
                    }
                    static setListeners() {
                        window.addEventListener("popstate", (e) => {
                            const t = e.state ? e.state.searchParams : a.searchParamsInitial;
                            t !== a.searchParamsPrev && a.renderPage(t, null, !1);
                        });
                    }
                    static toggleActiveFacets() {
                        let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        document.querySelectorAll(".js-facet-remove").forEach((t) => {
                            t.classList.toggle("disabled", e);
                        });
                    }
                    static renderPage(e, t) {
                        let r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                        a.searchParamsPrev = e;
                        const n = a.getSections();
                        document.getElementById("ProductGridContainer").classList.add("loading"),
                            n.forEach((r) => {
                                const n = `${window.location.pathname}?section_id=${r.section}&${e}`,
                                    o = (e) => e.url === n;
                                a.filterData.some(o) ? a.renderSectionFromCache(o, t) : a.renderSectionFromFetch(n, t);
                            }),
                            r && a.updateURLHash(e);
                    }
                    static renderSectionFromFetch(e, t) {
                        fetch(e)
                            .then((e) => e.text())
                            .then((r) => {
                                const o = r;
                                console.log({ html: o, url: e, event: t }),
                                    (a.filterData = [...a.filterData, { html: o, url: e }]),
                                    a.renderFilters(o, t),
                                    a.renderProductGridContainer(o),
                                    document.getElementById("ProductGridContainer").classList.remove("loading"),
                                    (0, n.VG)(document.querySelector("div.grid-archive__outer-container"));
                            });
                    }
                    static renderSectionFromCache(e, t) {
                        const r = a.filterData.find(e).html;
                        a.renderFilters(r, t), a.renderProductGridContainer(r), document.getElementById("ProductGridContainer").classList.remove("loading");
                    }
                    static renderProductGridContainer(e) {
                        (document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(e, "text/html").getElementById("ProductGridContainer").innerHTML),
                            d(),
                            document
                                .getElementById("ProductGridContainer")
                                .querySelectorAll(".icon")
                                .forEach((e) => {
                                    e.classList.add("loaded");
                                }),
                            (() => {
                                const e = [].slice.call(document.querySelectorAll("img"));
                                if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
                                    const t = new IntersectionObserver(function (e, t) {
                                        e.forEach(function (e) {
                                            if (e.isIntersecting) {
                                                const r = e.target;
                                                r.classList.contains("loaded") || (r.classList.add("loaded"), t.unobserve(r));
                                            }
                                        });
                                    });
                                    e.forEach(function (e) {
                                        t.observe(e);
                                    });
                                }
                            })(),
                            u(),
                            (0, n.nR)(),
                            m(),
                            f(),
                            (0, o.p)();
                    }
                    static renderFilters(e, t) {
                        const r = new DOMParser().parseFromString(e, "text/html"),
                            n = r.querySelectorAll("#FacetFiltersForm .js-filter"),
                            o = document.querySelector("#FacetFiltersForm");
                        if (!o) return;
                        const c = new Set(Array.from(n).map((e) => e.id));
                        o.querySelectorAll(".js-filter").forEach((e) => {
                            c.has(e.id) || e.remove();
                        });
                        const i = t && t.target ? t.target.closest(".js-filter") : null;
                        let s = o.querySelector(".facets__active");
                        if (!s) return;
                        Array.from(n).forEach((e) => {
                            const t = i && i.id === e.id,
                                l = document.getElementById(e.id);
                            if (l) {
                                t || (l.innerHTML = e.innerHTML), s.after(l), (s = l);
                            } else {
                                const t = document.importNode(e, !0);
                                s.after(t), (s = t);
                            }
                        }),
                            a.renderActiveFacets(r),
                            a.renderAdditionalElements(r);
                        const l = i ? Array.from(n).find((e) => e.id === i.id) : void 0;
                        if (l && i) {
                            const e = i.id;
                            if (e) {
                                a.renderCounts(l, document.getElementById(e));
                                const t = document.getElementById(e),
                                    r = t.classList.contains("mobile-facets__details") ? ".mobile-facets__close-button" : ".facets__summary",
                                    n = t.querySelector(r);
                                n && n.focus();
                            }
                        }
                    }
                    static renderActiveFacets(e) {
                        [".facets__active"].forEach((t) => {
                            const r = e.querySelector(t);
                            r && (document.querySelector(t).innerHTML = r.innerHTML);
                        }),
                            a.toggleActiveFacets(!1);
                            updateActiveFiltersCount();
                    }
                    static renderAdditionalElements(e) {
                        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t) => {
                            e.querySelector(t) && (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
                        });
                    }
                    static renderCounts(e, t) {
                        const r = t.querySelector("summary"),
                            n = e.querySelector("summary");
                        n && r && (r.outerHTML = n.outerHTML);
                    }
                    static updateURLHash(e) {
                        history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
                    }
                    static getSections() {
                        return [{ section: document.getElementById("grid-product").dataset.id }];
                    }
                    createSearchParams(e) {
                        const t = new FormData(e);
                        return new URLSearchParams(t).toString();
                    }
                    onSubmitForm(e, t) {
                        a.renderPage(e, t);
                    }
                    onSubmitHandler(e) {
                        e.preventDefault();
                        const t = document.querySelectorAll(".facet-form"),
                            r = [];
                        t.forEach((e) => {
                            ("FacetSortForm" !== e.id && "FacetFiltersForm" !== e.id && "FacetSearchForm" !== e.id) || r.push(this.createSearchParams(e));
                        });
                        let i = r.filter(Boolean).join("&"),
                            s = new URLSearchParams(i),
                            l = new URLSearchParams(window.location.search).get("sort_by");
                        l && !s.has("sort_by") && s.set("sort_by", l), this.onSubmitForm(s.toString(), e);
                    }
                    onActiveFilterClick(e) {
                        e.preventDefault(), a.toggleActiveFacets();
                        const t = -1 === e.currentTarget.href.indexOf("?") ? "" : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
                        a.renderPage(t);
                    }
                }
                (a.filterData = []), (a.searchParamsInitial = window.location.search.slice(1)), (a.searchParamsPrev = window.location.search.slice(1)), customElements.define("facet-filters-form", a), a.setListeners();
                class s extends HTMLElement {
                    constructor() {
                        super(), this.querySelectorAll("input").forEach((e) => e.addEventListener("change", this.onRangeChange.bind(this))), this.setMinAndMaxValues();
                    }
                    onRangeChange(e) {
                        this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
                    }
                    setMinAndMaxValues() {
                        const e = this.querySelectorAll("input"),
                            t = e[0],
                            r = e[1];
                        r.value && t.setAttribute("max", r.value), t.value && r.setAttribute("min", t.value), "" === t.value && r.setAttribute("min", 0), "" === r.value && t.setAttribute("max", r.getAttribute("max"));
                    }
                    adjustToValidValues(e) {
                        const t = Number(e.value),
                            r = Number(e.getAttribute("min")),
                            n = Number(e.getAttribute("max"));
                        t < r && (e.value = r), t > n && (e.value = n);
                    }
                }
                customElements.define("price-range", s);
                class l extends HTMLElement {
                    constructor() {
                        super(),
                            this.querySelector("a").addEventListener("click", (e) => {
                                e.preventDefault();
                                const t = this.closest("facet-filters-form#facets") || document.querySelector("facet-filters-form#facets");
                                t.onActiveFilterClick(e),
                                    t.querySelectorAll("input").forEach((t) => {
                                        e.target.closest("facet-remove").querySelector("span:not(.icon)").textContent.trim() === t.value && (t.checked = !1),
                                            "Clear all" === e.target.closest("facet-remove").querySelector("span:not(.icon)").textContent.trim() && (t.checked = !1);
                                    }),
                                    ("In stock" !== e.target.closest("facet-remove").querySelector("span:not(.icon)").textContent.trim() &&
                                        "Clear all" !== e.target.closest("facet-remove").querySelector("span:not(.icon)").textContent.trim()) ||
                                        (document.querySelector('input[name="filter.v.availability"]').checked = !1),
                                    "Clear all" === e.target.closest("facet-remove").querySelector("span:not(.icon)").textContent.trim() &&
                                        ((document.querySelector('input[name="filter.v.price.gte"]').value = ""), (document.querySelector('input[name="filter.v.price.lte"]').value = "")),
                                    t.querySelectorAll("select").forEach((t) => {
                                        e.target.textContent.trim() === t.value && (t.value = t.querySelector("option:first-child").textContent),
                                            "Clear all" === e.target.textContent.trim() && (t.value = t.querySelector("option:first-child").textContent);
                                    });
                            });
                    }
                }
                customElements.define("facet-remove", l);
                const d = () => {
                    const e = document.querySelectorAll("#ProductGridContainer .card").length;
                    e < 6 && document.querySelectorAll(".banner--large").forEach((e) => (e.style.display = "none")), e < 13 && document.querySelectorAll(".banner--small").forEach((e) => (e.style.display = "none"));
                };
                d();
               const u = () => {
                  document.querySelectorAll(".grid-archive").forEach((container) => {
                    let isOpen = false;
                    const toggleBtn = container.querySelector(".toggle-filtering");
                    const filtersContainer = container.querySelector(".grid-archive__filters-container");
                    const overlay = document.getElementById("overlay");
                
                    const closeFilters = () => {
                      isOpen = false;
                      container.classList.add("grid-archive__main-container--filters-hidden");
                      toggleBtn && toggleBtn.classList.remove("filters-off");
                      overlay.classList.remove("open", "overlay--all");
                      (0, n.My)(false);
                      (0, n.jW)(false);
                    };
                
                    const openFilters = () => {
                      isOpen = true;
                      container.classList.remove("grid-archive__main-container--filters-hidden");
                      toggleBtn && toggleBtn.classList.add("filters-off");
                      if (window.matchMedia("screen and (max-width: 767px)").matches) {
                        overlay.classList.add("open", "overlay--all");
                        (0, n.jW)(true);
                      }
                      (0, n.My)(true, closeFilters);
                    };
                
                    toggleBtn &&
                      toggleBtn.addEventListener("click", () => {
                        isOpen ? closeFilters() : openFilters();
                      });
                
                    // Click outside to close
                    if (filtersContainer) {
                      filtersContainer.addEventListener("click", (e) => {
                        if (e.target === filtersContainer) closeFilters();
                      });
                
                      const closeBtn = filtersContainer.querySelector(".facets__mobile-close");
                      closeBtn && closeBtn.addEventListener("click", closeFilters);
                    }
                
                    // Availability sync
                    const facetAvailability = document.querySelector(".facets__form .available-online");
                    const triggerAvailability = document.querySelector(".grid-archive__filter-triggers .available-online");
                
                    facetAvailability &&
                      facetAvailability.addEventListener("change", (e) => {
                        if (triggerAvailability) triggerAvailability.checked = e.target.checked;
                      });
                
                    triggerAvailability &&
                      triggerAvailability.addEventListener("click", () => {
                        facetAvailability && facetAvailability.click();
                      });
                  });
                };

                u(), (0, n.nR)();
                const m = () => {
                    document.querySelectorAll(".truncatable").forEach((e) => {
                        e.offsetHeight < e.scrollHeight && e.classList.add("truncated");
                    }),
                        document.querySelectorAll(".expand").forEach((e) => {
                            e.addEventListener("click", (t) => {
                                t.preventDefault(), t.stopPropagation(), e.parentNode.classList.add("expanded");
                            });
                        }),
                        document.querySelectorAll(".shrink").forEach((e) => {
                            e.addEventListener("click", (t) => {
                                t.preventDefault(), t.stopPropagation(), e.parentNode.classList.remove("expanded");
                            });
                        });
                };
                m();
                const f = () => {
                    if (((Shopify.queryParams = {}), location.search.length)) {
                        const e = location.search.substr(1).split("&");
                        for (let t = 0; t < e.length; t++) {
                            const r = e[t].split("=");
                            r.length && (Shopify.queryParams[decodeURIComponent(r[0])] = decodeURIComponent(r[1]));
                        }
                    }
                    document.querySelector(".sort-by select") &&
                        document.querySelector(".sort-by select").addEventListener("change", function (e) {
                            const t = e.target.value;
                            Shopify.queryParams.sort_by = t;
                        });
                };
                f();
            },
            1028: function (e, t, r) {
                r.d(t, {
                    p: function () {
                        return o;
                    },
                });
                var n = r(4559);
                const o = () => {
                    const e = document.querySelectorAll('form[action="/cart/add"]'),
                        t = document.getElementById("main-cart"),
                        r = document.getElementById("overlay"),
                        o = document.getElementById("mini-cart"),
                        c = document.querySelector("cart-service"),
                        i = document.querySelector("body"),
                        a = () => {
                            o.classList.remove("open"), r.classList.remove("open"), i.style.removeProperty("overflow"), (0, n.jW)(!1);
                        };
                    e.length &&
                        e.forEach((e) =>
                            e.addEventListener("submit", (i) => {
                                i.preventDefault(),
                                    i.stopPropagation(),
                                    i.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') &&
                                        (i.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addingToCart}`),
                                    i.target.querySelector('button[type="submit"]').classList.add("added"),
                                    (i.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "none"),
                                    (i.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "block");
                                const s = (0, n.Dz)("javascript");
                                (s.headers["X-Requested-With"] = "XMLHttpRequest"), delete s.headers["Content-Type"];
                                const l = new FormData(e);
                                l.append("sections", "main-cart"),
                                    (s.body = l),
                                    fetch(`${routes.cartAdd}`, s)
                                        .then((e) => e.json())
                                        .then(async (e) => {
                                            if (e.status) {
                                                if (
                                                    ((i.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "inline-flex"),
                                                    (i.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none"),
                                                    i.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') &&
                                                        (i.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addToCart}`),
                                                    "object" == typeof e.description)
                                                )
                                                    return Object.entries(e.description).forEach((e) => {
                                                        let [t, r] = e;
                                                        const n = `${r.join(", ")}`;
                                                        i.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + n + "</p>";
                                                    });
                                                i.target.querySelector(".product-converter__error").innerHTML = '<span class="icon loaded">error</span><p>' + e.description + "</p>";
                                            } else {
                                                if ("cart" === cartStrings.uxCart) return void (window.location.href = window.routes.cart);
                                                (i.target.querySelector(".product-converter__error").innerHTML = ""),
                                                    t && t.classList.add("added"),
                                                    c.renderItems(new DOMParser().parseFromString(e.sections["main-cart"], "text/html")),
                                                    "mini-cart" === cartStrings.uxCart && (o && o.classList.add("open"), r && (r.classList.add("open", "overlay--all"), (0, n.jW)(!0), (0, n.My)(!0, a))),
                                                    i.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)') &&
                                                        (i.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)').textContent = `${cartStrings.addedToCart}`),
                                                    i.target.querySelector('button[type="submit"]').classList.remove("added"),
                                                    i.target.querySelector('button[type="submit"]').classList.add("successful"),
                                                    (i.target.querySelector('button[type="submit"] > span.cart-icon').style.display = "flex"),
                                                    (i.target.querySelector('button[type="submit"] > svg.loading-icon').style.display = "none");
                                            }
                                        })
                                        .catch((e) => {
                                            console.error("Error:", e);
                                        });
                            })
                        );
                };
                o();
            },
            4559: function (e, t, r) {
                r.d(t, {
                    Dz: function () {
                        return n;
                    },
                    My: function () {
                        return a;
                    },
                    VG: function () {
                        return l;
                    },
                    jW: function () {
                        return o;
                    },
                    nR: function () {
                        return d;
                    },
                    sg: function () {
                        return s;
                    },
                });
                const n = function () {
                        return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}` } };
                    },
                    o = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const t = window.innerWidth - document.body.offsetWidth,
                            r = document.getElementById("nav-wrapper");
                        e
                            ? (document.body.classList.add("no-scroll"), (document.body.style.paddingRight = t + "px"), (r.style.paddingRight = t + "px"))
                            : (document.body.classList.remove("no-scroll"), (document.body.style.paddingRight = "0px"), (r.style.paddingRight = "0px"));
                    };
                let c = () => {};
                const i = (e) => {
                        "Escape" === e.key && (c(), window.removeEventListener("keydown", i));
                    },
                    a = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (c = t), e && window.addEventListener("keydown", i), e || window.removeEventListener("keydown", i);
                    };
                function s(e, t) {
                    const r = this;
                    let n;
                    return function () {
                        for (var o = arguments.length, c = new Array(o), i = 0; i < o; i++) c[i] = arguments[i];
                        clearTimeout(n),
                            (n = setTimeout(function () {
                                return e.apply(r, c);
                            }, t));
                    };
                }
                const l = (e) => {
                    Math.easeInOutQuad = function (e, t, r, n) {
                        return (e /= n / 2) < 1 ? (r / 2) * e * e + t : (-r / 2) * (--e * (e - 2) - 1) + t;
                    };
                    const t = document.getElementById("grid-archive-header"),
                        r = document.getElementById("nav-wrapper");
                    let n = 0,
                        o = 0;
                    t && (n = t.offsetHeight + 50), r && (o = r.offsetHeight + 50);
                    const c = e.offsetTop - n - o,
                        i = window.scrollY,
                        a = c - i;
                    let s = 0;
                    const l = () => {
                        s += 5;
                        const e = Math.easeInOutQuad(s, i, a, 200);
                        window.scrollTo(0, e), s < 200 && setTimeout(l, 5);
                    };
                    l();
                };
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href"),
                            r = document.querySelector(t);
                        l(r);
                    });
                });
                const d = () => {
                    const e = document.querySelector(".grid-archive__content");
                    document.querySelector(".grid-archive__subnav .cols") &&
                        (document.querySelectorAll(".view-icon-desktop").forEach((t) => {
                            t.onclick = function () {
                                document.querySelectorAll(".view-icon-desktop").forEach((e) => {
                                    e.classList.remove("active");
                                }),
                                    this.classList.add("active"),
                                    localStorage.setItem("columns-desktop", t.dataset.columns),
                                    4 == t.dataset.columns
                                        ? (e.classList.remove("grid-archive__content--three-col"), e.classList.add("grid-archive__content--four-col"))
                                        : (e.classList.add("grid-archive__content--three-col"), e.classList.remove("grid-archive__content--four-col"));
                            };
                        }),
                        document.querySelectorAll(".view-icon-mobile").forEach((t) => {
                            t.onclick = function () {
                                document.querySelectorAll(".view-icon-mobile").forEach((e) => {
                                    e.classList.remove("active");
                                }),
                                    this.classList.add("active"),
                                    localStorage.setItem("columns-mobile", t.dataset.columns),
                                    1 == t.dataset.columns
                                        ? (e.classList.remove("grid-archive__content--two-col"), e.classList.add("grid-archive__content--one-col"))
                                        : (e.classList.add("grid-archive__content--two-col"), e.classList.remove("grid-archive__content--one-col"));
                            };
                        }),
                        4 == localStorage.getItem("columns-desktop") &&
                            (e.classList.remove("grid-archive__content--three-col"),
                            e.classList.add("grid-archive__content--four-col"),
                            document.querySelector(".three-col").classList.remove("active"),
                            document.querySelector(".four-col").classList.add("active")),
                        1 == localStorage.getItem("columns-mobile") &&
                            (e.classList.remove("grid-archive__content--two-col"),
                            e.classList.add("grid-archive__content--one-col"),
                            document.querySelector(".two-col").classList.remove("active"),
                            document.querySelector(".one-col").classList.add("active")));
                };
            },
        },
        r = {};
    function n(e) {
        var o = r[e];
        if (void 0 !== o) return o.exports;
        var c = (r[e] = { exports: {} });
        return t[e].call(c.exports, c, c.exports, n), c.exports;
    }
    (n.m = t),
        (e = []),
        (n.O = function (t, r, o, c) {
            if (!r) {
                var i = 1 / 0;
                for (d = 0; d < e.length; d++) {
                    (r = e[d][0]), (o = e[d][1]), (c = e[d][2]);
                    for (var a = !0, s = 0; s < r.length; s++)
                        (!1 & c || i >= c) &&
                        Object.keys(n.O).every(function (e) {
                            return n.O[e](r[s]);
                        })
                            ? r.splice(s--, 1)
                            : ((a = !1), c < i && (i = c));
                    if (a) {
                        e.splice(d--, 1);
                        var l = o();
                        void 0 !== l && (t = l);
                    }
                }
                return t;
            }
            c = c || 0;
            for (var d = e.length; d > 0 && e[d - 1][2] > c; d--) e[d] = e[d - 1];
            e[d] = [r, o, c];
        }),
        (n.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return n.d(t, { a: t }), t;
        }),
        (n.d = function (e, t) {
            for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
        }),
        (n.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (n.j = 115),
        (function () {
            var e = { 115: 0, 741: 0, 457: 0 };
            n.O.j = function (t) {
                return 0 === e[t];
            };
            var t = function (t, r) {
                    var o,
                        c,
                        i = r[0],
                        a = r[1],
                        s = r[2],
                        l = 0;
                    if (
                        i.some(function (t) {
                            return 0 !== e[t];
                        })
                    ) {
                        for (o in a) n.o(a, o) && (n.m[o] = a[o]);
                        if (s) var d = s(n);
                    }
                    for (t && t(r); l < i.length; l++) (c = i[l]), n.o(e, c) && e[c] && e[c][0](), (e[c] = 0);
                    return n.O(d);
                },
                r = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
            r.forEach(t.bind(null, 0)), (r.push = t.bind(null, r.push.bind(r)));
        })();
    var o = n.O(void 0, [96], function () {
        return n(5170);
    });
    o = n.O(o);
})();

